/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type { ListK12DistrictsCountiesQueryResponse } from '../types/ListK12DistrictsCounties'

function getListK12DistrictsCountiesUrl() {
  const res = { method: 'GET', url: `/api/v1/k12/districts/counties/` as const }
  return res
}

/**
 * @summary List distinct K-12 district counties as {label, value} options
 * {@link /api/v1/k12/districts/counties/}
 */
export async function listK12DistrictsCounties(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListK12DistrictsCountiesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListK12DistrictsCountiesUrl().url.toString(),
    ...requestConfig,
  })
  return res.data
}
